import { inherits as _inherits, createClass as _createClass, wrapNativeSuper as _wrapNativeSuper, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../../../_virtual/_rollupPluginBabelHelpers.js';

/**
 * Copyright 2021, IntraLinks, Inc. All rights reserved.
 */
var IlFrameworkError = /*#__PURE__*/function (_Error) {
  function IlFrameworkError() {
    var _this;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    _classCallCheck(this, IlFrameworkError);
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    _this = _callSuper(this, IlFrameworkError, [message].concat(args));
    _this.message = message;
    return _this;
  }
  _inherits(IlFrameworkError, _Error);
  return _createClass(IlFrameworkError);
}(/*#__PURE__*/_wrapNativeSuper(Error));

export { IlFrameworkError };
